export enum SecondFactorTitleEnum {
    securePassword = 'Clave segura',
    debitCardPassword = 'Clave tarjeta débito',
    token = 'Token',
    questions = 'Preguntas de seguridad',
}



// WEBPACK FOOTER //
// ./src/app/bdb-second-factor-selector/models/second-factor-title-enum.ts